import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertTriangle, PlusCircle } from "lucide-react";

/**
 * Tells the operator exactly what is missing to run the analysis and how to
 * fix it. `variant`:
 *  - "none": no machine selected at all (the wizard cannot move on)
 *  - "process": a confirmed process has no machine that can perform it
 *    (the quote still runs: that operation is priced as outsourced)
 */
export default function MissingMachineNotice({ variant, processes = [], onPickFromCatalog }) {
  const { t } = useTranslation();
  const isBlocking = variant === "none";
  const tone = isBlocking
    ? "border-rose-500/40 bg-rose-500/10 text-rose-200"
    : "border-amber-500/40 bg-amber-500/10 text-amber-200";

  return (
    <div className={`mb-5 p-4 rounded-md border ${tone}`} data-testid={`missing-machine-${variant}`}>
      <div className="flex items-start gap-2.5">
        <AlertTriangle size={16} className="mt-0.5 shrink-0" />
        <div className="text-sm space-y-1">
          <div className="font-medium">
            {isBlocking
              ? t("newQuote.noMachineTitle")
              : t("newQuote.processNoMachineTitle", {
                  processes: processes.map((p) => t(`extractionConfirm.proc.${p}`, p)).join(", "),
                })}
          </div>
          <div className="text-xs opacity-90">
            {isBlocking ? t("newQuote.noMachineBody") : t("newQuote.processNoMachineBody")}
          </div>
          <div className="flex flex-wrap items-center gap-3 pt-1.5">
            {onPickFromCatalog && (
              <button type="button" onClick={onPickFromCatalog}
                className="text-xs underline underline-offset-2 hover:opacity-80"
                data-testid={`missing-machine-${variant}-catalog`}>
                {t("newQuote.pickFromCatalog")}
              </button>
            )}
            <Link to="/machines" className="text-xs inline-flex items-center gap-1.5 underline underline-offset-2 hover:opacity-80"
              data-testid={`missing-machine-${variant}-add`}>
              <PlusCircle size={12} /> {t("newQuote.addMachineLink")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
